const ACCESS_TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refreshToken';
const AUTH_TOKENS_UPDATED_EVENT = 'auth:tokens-updated';
const AUTH_LOGOUT_EVENT = 'auth:logout';

function dispatchAuthEvent(name, detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY) || null;
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY) || null;
}

export function setAuthTokens({ access, refresh }) {
  if (access) {
    localStorage.setItem(ACCESS_TOKEN_KEY, access);
  }

  if (refresh) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refresh);
  }

  dispatchAuthEvent(AUTH_TOKENS_UPDATED_EVENT, {
    access: getAccessToken(),
    refresh: getRefreshToken(),
  });
}

export function clearAuthTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  dispatchAuthEvent(AUTH_LOGOUT_EVENT);
}

export function onAuthTokensUpdated(listener) {
  if (typeof window === 'undefined') return () => {};

  const handler = (event) => listener(event?.detail || {});
  window.addEventListener(AUTH_TOKENS_UPDATED_EVENT, handler);
  return () => window.removeEventListener(AUTH_TOKENS_UPDATED_EVENT, handler);
}

export function onAuthLogout(listener) {
  if (typeof window === 'undefined') return () => {};

  window.addEventListener(AUTH_LOGOUT_EVENT, listener);
  return () => window.removeEventListener(AUTH_LOGOUT_EVENT, listener);
}
